import React from "react"
import { useHistory } from "react-router-dom"
import jblSpeaker from "../../../assets/jbl-speaker.png"
// import shoppingBag from "../../assets/shopping-bag.svg";
// import heartIcon from "../../assets/heart.svg";

export const GiftCard = props => {
  const { first_name, last_name, email } = props.buyer
  const orderType = props.orderType

  const history = useHistory()
  return (
    <>
      <div className="gift-tracker__order-card shadow p-5 my-5">
        <div className="flex">
          <div className=" buyer-info w-3/5 mobiles:w-2/3">
            <h1> {`${first_name} ${last_name}`} </h1>
            <p>{email}</p>
            <div className="order-images flex mt-3 flex-wrap">
              {props.cartItems.map(orderItem => {
                return (
                  <img src={orderItem.product.images[0]} alt="jblspeaker" />
                )
              })}
            </div>
          </div>
          <div className="w-1/5 mobiles:w-1/3 mr-2">
            <div className="order-amount mobiles:text-right">
              <h2>NGN {parseInt(props.totalCost).toLocaleString("en-NG")} </h2>
            </div>
          </div>
          <div className="w-1/5 mobiles:hidden">
            {orderType === "PRODUCT" ? (
              <div className="btn-wrapper">
                <button
                  className="convert-button p-3 my-2 rounded"
                  onClick={() => {
                    history.push(`/gift-tracker/cash/${props.orderId}`)
                  }}
                >
                  Convert to cash
                </button>
                <button
                  className="send-button p-3 my-2 rounded"
                  onClick={() => {
                    history.push(`/gift-tracker/gift/${props.orderId}`)
                  }}
                >
                  Send Now
                </button>
              </div>
            ) : (
              <div className="btn-wrapper">
                <button
                  className="convert-button p-3 my-2 rounded"
                  onClick={() => {
                    history.push(`/gift-tracker/cash/${props.orderId}`)
                  }}
                >
                  Credit Request
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="mobile:flex flex-wrap hidden mobiles:block">
          {orderType === "PRODUCT" ? (
            <div className="btn-wrapper">
              <button
                className="convert-button p-3 rounded"
                onClick={() => {
                  history.push(`/gift-tracker/cash/${props.orderId}`)
                }}
              >
                Convert to cash
              </button>
              <button className="send-button p-3">Send Now</button>
            </div>
          ) : (
            <div className="btn-wrapper">
              <button
                className="convert-button p-3 rounded"
                onClick={() => {
                  history.push(`/gift-tracker/cash/${props.orderId}`)
                }}
              >
                Credit Request
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export const SampleCard = () => {
  return (
    <div className="sample-card">
      <div>
        <input
          type="checkbox"
          checked={true}
          onChange={() => {
            console.log()
          }}
          value="new gift"
        />
      </div>
      <div className="card-info"></div>
    </div>
  )
}
